import { render, staticRenderFns } from "./juniorCollege.vue?vue&type=template&id=e7b018a6&scoped=true&"
import script from "./juniorCollege.vue?vue&type=script&lang=js&"
export * from "./juniorCollege.vue?vue&type=script&lang=js&"
import style0 from "./juniorCollege.vue?vue&type=style&index=0&id=e7b018a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7b018a6",
  null
  
)

export default component.exports